import { render, staticRenderFns } from "./ListaComposiciones.vue?vue&type=template&id=4f5a57af&"
import script from "./ListaComposiciones.vue?vue&type=script&lang=js&"
export * from "./ListaComposiciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports